import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterialV5 from "./DeleteMaterialV5";
import CatalogProductDetailModalV5 from "../Common/CatalogModal/CatalogProductDetailModalV5";

import MaterialBarCodeModal from "./MaterialBarCodeModal";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import ShowUploadImageV5 from "./ShowUploadImageV5";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  addMaterial,
  //   getMaterialList,
  materialBarcodeList,
} from "../../../../redux/feature/customer_app/customerSlice";
// import MaterialHBModalV5 from "./MaterialHBModalV5";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { formatDate } from "../../../../common/Validations";
import MaterialListQualityCheckModal from "./MaterialListQualityCheckModal";
import ConversionHistoryModal from "./ConversionHistoryModal ";
import Barcode from "react-barcode";
// eslint-disable-next-line
import QRCode from "react-qr-code";

import { OverlayTrigger, Tooltip, Modal, Button, Form } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import toast from "react-hot-toast";
import MaterialHBModalV5Barcode from "./MaterialHBModalV5Barcode";

const MaterialBarcodeList = () => {
  localStorage.setItem("menu", "Barcode");
  localStorage.setItem("submenu", "Sales Product");

  const dispatch = useDispatch();

  let materialData = useSelector(
    (state) => state?.customer?.materialBarcode?.data,
  ); // User Details from Store
  let materialTable = useSelector(
    (state) => state?.customer?.materialBarcode?.pagination,
  );

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(100);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowAddProductMaterial, setModalShowAddProductMaterial] =
    useState();
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);

  const [activeFilters, setActiveFilters] = useState([]);

  const target = useRef(null);

  //   const getRoiExpiryDate = (createdOn) => {
  //   if (!createdOn) return "--";

  //   const date = new Date(createdOn);
  //   date.setMonth(date.getMonth() + 36);

  //   return date.toISOString().split("T")[0]; // YYYY-MM-DD
  // };

  const getRoiExpiryDate = (createdOn) => {
    if (!createdOn) return null;

    const date = new Date(createdOn);
    date.setMonth(date.getMonth() + 36);

    return date; // return Date object
  };

  const getRoiAgeMonthsDays = (createdOn) => {
    if (!createdOn) return "--";

    const start = new Date(createdOn);
    const today = new Date();

    if (today < start) return "0 Days";

    let years = today.getFullYear() - start.getFullYear();
    let months = today.getMonth() - start.getMonth();
    let days = today.getDate() - start.getDate();

    if (days < 0) {
      // previous month days
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months -= 1;
    }

    if (months < 0) {
      months += 12;
      years -= 1;
    }

    const totalMonths = years * 12 + months;

    let result = "";
    if (totalMonths > 0)
      result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
    result += `${days} Day${days !== 1 ? "s" : ""}`;

    return result.trim();
  };

  const [qcType, setQcType] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [showQCModal, setShowQCModal] = useState(false);
  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  // --- New States for Print Quantity ---
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printQuantity, setPrintQuantity] = useState(1); // Default 1 copy
  const [printType, setPrintType] = useState(""); // "BARCODE" or "QR"
  const [printRowData, setPrintRowData] = useState(null); // Selected row data

  useEffect(() => {
    if (!materialData || materialData.length === 0) return;

    const qcItems = [];

    materialData.forEach((row) => {
      // API lo already QC details unte
      if (row.qualityCheckDetails?.length) {
        row.qualityCheckDetails.forEach((qc) => {
          qcItems.push({
            ...row,
            ...qc, // modelMatch, brandMatch etc
            grnItemNr: qc.grnItemNr,
            qcType: qc.qcType,

            hasPhysicalQC: qc.qcType === "PHYSICAL",
            hasSpecificationQC: qc.qcType === "SPECIFICATION",
          });
        });
      }
    });

    setQualityCheckItems(qcItems);
  }, [materialData]);

  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    // console.log("Viewing QC:", { type, row, savedQC }); // Debug

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}),
    });
    setShowQCModal(true);
  };
  // eslint-disable-next-line
  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };
  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    // console.log("Opening QC Modal:", { type, row, existingQC });

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}),
    });
    setShowQCModal(true);
  };

  // new
  const handleSaveQualityCheck = (qcPayload) => {
    setQualityCheckItems((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.grnItemNr === qcPayload.grnItemNr &&
          item.qcType === qcPayload.qcType,
      );

      // UPDATE EXISTING
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        };
        return updated;
      }

      // ADD NEW
      return [
        ...prev,
        {
          ...qcPayload,
          hasPhysicalQC: qcPayload.qcType === "PHYSICAL",
          hasSpecificationQC: qcPayload.qcType === "SPECIFICATION",
        },
      ];
    });
  };

  const barcodeRef = useRef();
  const qrCodeRef = useRef();

  const PrintableQrcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    const qrValue = `
    Code: ${data.materialCode}
    MRP: ${data.mrPrice} INR
    Barcode ID: ${data.barcode}
  `;

    return (
      <div ref={ref} style={{ padding: "20px", width: "100%" }}>
        {/* Container flex-wrap tho unte items automatic ga kindaki vasthayi */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "15px",
          }}
        >
          {items.map((_, index) => (
            <div
              key={index}
              style={{
                width: "30%", // 3 items per row ravali ante 30-32% ivvali
                border: "1px dashed #ccc", // Cutting ki easy ga border
                padding: "15px",
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                pageBreakInside: "avoid", // Item sagam lo cut avvakunda chusukuntundi
              }}
            >
              <div style={{ textAlign: "center" }}>
                <QRCode value={qrValue} size={120} />{" "}
                {/* Size konchem taggincha fit avvadaniki */}
                <div style={{ marginTop: "10px", fontSize: "12px" }}>
                  <p className="m-0">
                    <strong>{data.materialCode}</strong>
                  </p>
                  <p className="m-0">{data.barcode}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  });
  //test-1
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //        @media print {
  //          @page {
  //            size: 30mm 50mm;
  //            margin: 0;
  //          }
  //          body * { visibility: hidden; }
  //          #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //          #barcode-print-area {
  //            position: absolute;
  //            left: 2mm;
  //            top: 2mm;
  //            width: 30mm;
  //          }
  //          .barcode-label {
  //            width: 30mm;
  //            height: 50mm;
  //            page-break-after: always;
  //            overflow: hidden;
  //            box-sizing: border-box;
  //          }
  //        }
  //      `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "113px",
  //               height: "189px",
  //               //  border: "1.5px solid #000",
  //               borderRadius: "3px",
  //               display: "flex",
  //               flexDirection: "row",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               margin: "6px",
  //               marginBottom: "8px",
  //               overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               gap: "2px",
  //               position: "relative", //  add this
  //             }}
  //           >
  //             {/*  Barcode wrapper — strictly contained */}
  //             <div
  //               style={{
  //                 width: "85px",
  //                 height: "160px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 flexShrink: 0,
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   width: "155px",
  //                   height: "80px",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <Barcode
  //                   value={data.barcode || "N/A"}
  //                   width={1.5}
  //                   height={65}
  //                   format="CODE128"
  //                   displayValue={true}
  //                   fontSize={9}
  //                   margin={2}
  //                   background="#FFFFFF"
  //                   lineColor="#000000"
  //                 />

  //               </div>
  //             </div>

  //             {/*  Material name — right side */}
  //             <div
  //               style={{
  //                 width: "20px",
  //                 height: "160px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 flexShrink: 0,
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   whiteSpace: "nowrap",
  //                   fontSize: "6px",
  //                   fontWeight: "bold",
  //                   width: "155px",
  //                   textAlign: "center",
  //                   display: "block",
  //                 }}
  //               >
  //               test-1  {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  // test-2
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //     if (!data) return null;

  //     const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //     return (
  //       <>
  //         <style>{`
  //          @media print {
  //            @page {
  //              size: 30mm 50mm;
  //              margin: 0;
  //            }
  //            body * { visibility: hidden; }
  //            #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //            #barcode-print-area {
  //              position: absolute;
  //              left: 2mm;
  //              top: 2mm;
  //              width: 30mm;
  //            }
  //            .barcode-label {
  //              width: 30mm;
  //              height: 50mm;
  //              page-break-after: always;
  //              overflow: hidden;
  //              box-sizing: border-box;
  //            }
  //          }
  //        `}</style>

  //         <div id="barcode-print-area" ref={ref}>
  //           {items.map((_, index) => (
  //             <div
  //               key={index}
  //               className="barcode-label"
  //               style={{
  //                 width: "113px",
  //                 height: "189px",
  //                 //  border: "1.5px solid #000",
  //                 borderRadius: "3px",
  //                 display: "flex",
  //                 flexDirection: "row",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 margin: "6px",
  //                 marginBottom: "8px",
  //                 overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
  //                 boxSizing: "border-box",
  //                 padding: "4px",
  //                 gap: "2px",
  //                 position: "relative", //  add this
  //               }}
  //             >
  //               {/*  Barcode wrapper — strictly contained */}
  //               <div
  //                 style={{
  //                   width: "85px",
  //                   height: "160px",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   overflow: "hidden",
  //                   flexShrink: 0,
  //                 }}
  //               >
  //                 <div
  //                   style={{
  //                     transform: "rotate(90deg)",
  //                     transformOrigin: "center center",
  //                     width: "140px",
  //                     height: "80px",
  //                     display: "flex",
  //                     alignItems: "center",
  //                     justifyContent: "center",
  //                       padding: "6px",
  //   background: "#FFFFFF"
  //                   }}
  //                 >

  //                 <Barcode
  //   value={data.barcode || "N/A"}
  //   width={2}          // ← increase from 1.5 to 2
  //   height={70}        // ← slightly taller
  //   format="CODE128"
  //   displayValue={true}
  //   fontSize={9}
  //   margin={3}         // ← more quiet zone margin
  //   background="#FFFFFF"
  //   lineColor="#000000"
  // />

  //                 </div>
  //               </div>

  //               {/*  Material name — right side */}
  //               <div
  //                 style={{
  //                   width: "20px",
  //                   height: "160px",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   overflow: "hidden",
  //                   flexShrink: 0,
  //                 }}
  //               >
  //                 <span
  //                   style={{
  //                     transform: "rotate(90deg)",
  //                     transformOrigin: "center center",
  //                     whiteSpace: "nowrap",
  //                     fontSize: "6px",
  //                     fontWeight: "bold",
  //                     width: "155px",
  //                     textAlign: "center",
  //                     display: "block",
  //                   }}
  //                 >
  //                  test-2  {data.materialCode} | {data.materialDescription}
  //                 </span>
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </>
  //     );
  //   });
  //test-3
  //   const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //     if (!data) return null;

  //     const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //     return (
  //       <>
  //         <style>{`
  //          @media print {
  //            @page {
  //              size: 30mm 50mm;
  //              margin: 0;
  //            }
  //            body * { visibility: hidden; }
  //            #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //            #barcode-print-area {
  //              position: absolute;
  //              left: 2mm;
  //              top: 2mm;
  //              width: 30mm;
  //            }
  //            .barcode-label {
  //              width: 30mm;
  //              height: 50mm;
  //              page-break-after: always;
  //              overflow: hidden;
  //              box-sizing: border-box;
  //            }
  //          }
  //        `}</style>

  //         <div id="barcode-print-area" ref={ref}>
  //           {items.map((_, index) => (
  //             <div
  //               key={index}
  //               className="barcode-label"
  //               style={{
  //                 width: "113px",
  //                 height: "189px",
  //                 //  border: "1.5px solid #000",
  //                 borderRadius: "3px",
  //                 display: "flex",
  //                 flexDirection: "row",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 margin: "6px",
  //                 marginBottom: "8px",
  //                 overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
  //                 boxSizing: "border-box",
  //                 padding: "4px",
  //                 gap: "2px",
  //                 position: "relative", //  add this
  //               }}
  //             >
  //             {/* Barcode wrapper — strictly contained */}
  // <div
  //   style={{
  //     width: "100px",      // ← increased from 85px
  //     height: "175px",     // ← increased from 160px
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     overflow: "hidden",
  //     flexShrink: 0,
  //   }}
  // >
  //   <div
  //     style={{
  //       transform: "rotate(90deg)",
  //       transformOrigin: "center center",
  //       width: "170px",    // ← increased from 140px
  //       height: "95px",    // ← increased from 80px
  //       display: "flex",
  //       alignItems: "center",
  //       justifyContent: "center",
  //     }}
  //   >
  //     <Barcode
  //       value={data.barcode || "N/A"}
  //       width={2}
  //       height={85}        // ← increased from 65-70 — this controls bar height
  //       format="CODE128"
  //       displayValue={true}
  //       fontSize={9}
  //       margin={2}
  //       background="#FFFFFF"
  //       lineColor="#000000"
  //     />
  //   </div>
  // </div>

  // {/* Material name — right side */}
  // <div
  //   style={{
  //     width: "18px",       // ← slightly reduced to give barcode more room
  //     height: "175px",
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     overflow: "hidden",
  //     flexShrink: 0,
  //   }}
  // >
  //   <span
  //     style={{
  //       transform: "rotate(90deg)",
  //       transformOrigin: "center center",
  //       whiteSpace: "nowrap",
  //       fontSize: "6px",
  //       fontWeight: "bold",
  //       width: "170px",    // ← match rotated width
  //       textAlign: "center",
  //       display: "block",
  //     }}
  //   >
  //     test-3 {data.materialCode } | {data.materialDescription}
  //   </span>
  // </div>

  //             </div>
  //           ))}
  //         </div>
  //       </>
  //     );
  //   });
  //test-4.1 //not for test
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 50mm 25mm;   /* landscape: width x height */
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 50mm;
  //             height: 25mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "189px",       /* ~50mm at 96dpi */
  //               height: "94px",       /* ~25mm at 96dpi */
  //               display: "flex",
  //               flexDirection: "row",
  //               alignItems: "center",
  //               justifyContent: "space-between",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "3px 4px",
  //               gap: "3px",
  //               background: "#fff",
  //             }}
  //           >
  //             {/* Barcode — no rotation needed, fits naturally landscape */}
  //             <div
  //               style={{
  //                 flex: 1,
  //                 height: "100%",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <Barcode
  //                 value={data.barcode || "N/A"}
  //                 width={1.2}          /* bar width in px — keep low */
  //                 height={55}          /* bar height in px */
  //                 format="CODE128"
  //                 displayValue={true}
  //                 fontSize={7}
  //                 margin={1}
  //                 background="#FFFFFF"
  //                 lineColor="#000000"
  //               />
  //             </div>

  //             {/* Material name — right strip, rotated */}
  //             <div
  //               style={{
  //                 width: "18px",
  //                 height: "88px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 flexShrink: 0,
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   whiteSpace: "nowrap",
  //                   fontSize: "6px",
  //                   fontWeight: "bold",
  //                   width: "85px",
  //                   textAlign: "center",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-4.2 //not for test
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 25mm 50mm;   /* portrait: narrow width, tall height */
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 25mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",     /* ~25mm */
  //               height: "189px",   /* ~50mm */
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "3px",
  //               background: "#fff",
  //             }}
  //           >
  //             {/* Barcode — no rotation, renders naturally vertical in portrait label */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "150px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <Barcode
  //                 value={data.barcode || "N/A"}
  //                 width={1.2}
  //                 height={110}
  //                 format="CODE128"
  //                 displayValue={true}
  //                 fontSize={7}
  //                 margin={2}
  //                 background="#FFFFFF"
  //                 lineColor="#000000"
  //               />
  //             </div>

  //             {/* Divider */}
  //             <div style={{
  //               width: "85px",
  //               height: "1px",
  //               background: "#ccc",
  //               margin: "2px 0",
  //             }} />

  //             {/* Material name — bottom strip, normal horizontal text */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "30px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 padding: "0 2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "6px",
  //                   fontWeight: "bold",
  //                   textAlign: "center",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.3",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-4.3 //not for test
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 25mm 50mm;   /* portrait: narrow width, tall height */
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 25mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",     /* ~25mm */
  //               height: "189px",   /* ~50mm */
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "3px",
  //               background: "#fff",
  //             }}
  //           >
  //             {/* Barcode — no rotation, renders naturally vertical in portrait label */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "150px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <Barcode
  //                 value={data.barcode || "N/A"}
  //                 width={1.2}
  //                 height={110}
  //                 format="CODE128"
  //                 displayValue={true}
  //                 fontSize={7}
  //                 margin={2}
  //                 background="#FFFFFF"
  //                 lineColor="#000000"
  //               />
  //             </div>

  //             {/* Divider */}
  //             <div style={{
  //               width: "85px",
  //               height: "1px",
  //               background: "#ccc",
  //               margin: "2px 0",
  //             }} />

  //             {/* Material name — bottom strip, normal horizontal text */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "30px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 padding: "0 2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "6px",
  //                   fontWeight: "bold",
  //                   textAlign: "center",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.3",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-5 //not for test
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "160px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "3px",
  //               background: "#fff",
  //             }}
  //           >
  //             {/* Rotated barcode container */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "150px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 flexShrink: 0,
  //               }}
  //             >
  //               {/*
  //                 Barcode natural size: ~145px wide x 80px tall
  //                 After rotate(90deg): 80px wide x 145px tall
  //                 → fits inside 88px x 150px container ✓
  //               */}
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   width: "145px",   /* natural barcode width → becomes height */
  //                   height: "80px",   /* natural barcode height → becomes width */
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <style>{`
  //         #barcode-print-area svg {
  //           width: 200px !important;
  //           height: 80px !important;
  //           display: block;
  //         }
  //       `}</style>

  //                 <Barcode
  //         value={data.barcode || "N/A"}
  //         width={1}
  //         height={65}
  //         format="CODE128"
  //         displayValue={true}
  //         fontSize={7}
  //         margin={0}
  //         background="#FFFFFF"
  //         lineColor="#000000"
  //       />
  //               </div>
  //             </div>

  //             {/* Divider */}
  //             <div style={{
  //               width: "85px",
  //               height: "1px",
  //               background: "#ccc",
  //               margin: "2px 0",
  //             }} />

  //             {/* Material info at bottom */}
  //             <div
  //               style={{
  //                 width: "88px",
  //                 height: "30px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 padding: "0 2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "6px",
  //                   fontWeight: "bold",
  //                   textAlign: "center",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.3",
  //                 }}
  //               >
  //                 test-5{/* {data.materialCode} | {data.materialDescription} */}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-6
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }

  //         /* Higher resolution rendering */
  //         @media print and (min-resolution: 200dpi) {
  //           .barcode-label svg {
  //             shape-rendering: crispEdges;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "30mm",
  //               height: "50mm",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               justifyContent: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "2mm 1mm",
  //               background: "#fff",
  //             }}
  //           >
  //             {/* Rotated barcode container - enlarged */}
  //             <div
  //               style={{
  //                 width: "26mm",
  //                 height: "38mm",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 flexShrink: 0,
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   width: "36mm",
  //                   height: "24mm",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <style>{`
  //                   #barcode-print-area svg {
  //                     width: 38mm !important;
  //                     height: 24mm !important;
  //                     display: block;
  //                   }
  //                 `}</style>

  //                 <Barcode
  //                   value={data.barcode || "N/A"}
  //                   width={1.2}
  //                   height={22}
  //                   format="CODE128"
  //                   displayValue={true}
  //                   fontSize={8}
  //                   margin={0}
  //                   background="#FFFFFF"
  //                   lineColor="#000000"
  //                 />
  //               </div>
  //             </div>

  //             {/* Divider */}
  //             <div style={{
  //               width: "26mm",
  //               height: "0.3mm",
  //               background: "#999",
  //               margin: "1.5mm 0",
  //             }} />

  //             {/* Material info at bottom - enlarged */}
  //             <div
  //               style={{
  //                 width: "28mm",
  //                 height: "8mm",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //                 padding: "0 1mm",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   textAlign: "center",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.3",
  //                 }}
  //               >
  //                 {data.materialCode || "N/A"} | {data.materialDescription || "test-5"}
  //               </span>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-7
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 25mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 25mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }

  //         .barcode-svg-wrapper svg {
  //           width: 100% !important;
  //           height: 100% !important;
  //           display: block;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               background: "#fff",
  //             }}
  //           >

  //             {/* ========== 1. TEXT ON TOP ========== */}
  //             <div
  //               style={{
  //                 width: "86px",
  //                 padding: "2px 0",
  //                 borderBottom: "1px solid #ccc",
  //                 marginBottom: "4px",
  //                 textAlign: "center",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.4",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>

  //             {/* ========== 2. BARCODE BELOW (fills rest) ========== */}
  //             <div
  //               style={{
  //                 flex: 1,
  //                 width: "86px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   width: "160px",
  //                   height: "82px",
  //                 }}
  //               >
  //                 <div
  //                   className="barcode-svg-wrapper"
  //                   style={{
  //                     width: "160px",
  //                     height: "82px",
  //                     overflow: "hidden",
  //                   }}
  //                 >
  //                   <Barcode
  //                     value={data.barcode || "N/A"}
  //                     width={1.6}
  //                     height={70}
  //                     format="CODE128"
  //                     displayValue={true}
  //                     fontSize={8}
  //                     margin={0}
  //                     background="#FFFFFF"
  //                     lineColor="#000000"
  //                   />
  //                 </div>
  //               </div>
  //             </div>

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-8
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //         .barcode-svg-wrapper svg {
  //           width: 100% !important;
  //           height: 100% !important;
  //           display: block;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               background: "#fff",
  //             }}
  //           >

  //             {/* ===== 1. MATERIAL TEXT ON TOP ===== */}
  //             {/* <div
  //               style={{
  //                 width: "86px",
  //                 padding: "2px 0",
  //                 borderBottom: "1px solid #ccc",
  //                 marginBottom: "4px",
  //                 textAlign: "center",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.4",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div> */}

  //             {/* ===== 2. BARCODE (no displayValue, rotated) ===== */}
  //             <div
  //               style={{
  //                 flex: 1,
  //                 width: "86px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   width: "155px",
  //                   height: "80px",
  //                 }}
  //               >
  //                 <div
  //                   className="barcode-svg-wrapper"
  //                   style={{ width: "155px", height: "60px", overflow: "hidden" }}
  //                 >
  //                   <Barcode
  //                     value={data.barcode || "N/A"}
  //                     width={2}
  //                     height={70}
  //                     format="CODE128"
  //                     displayValue={false}   /* ← turn OFF rotated text */
  //                     margin={0}
  //                     background="#FFFFFF"
  //                     lineColor="#000000"
  //                   />
  //                 </div>
  //               </div>
  //             </div>

  //             {/* ===== 3. BARCODE NUMBER TEXT (horizontal, below bars) ===== */}
  //             <div
  //               style={{
  //                 width: "86px",
  //                 textAlign: "center",
  //                 marginTop: "2px",
  //               }}
  //             >
  //               {/* <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontFamily: "monospace",
  //                   letterSpacing: "1px",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.barcode || "N/A"}
  //               </span> */}
  //             </div>

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-9
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }

  //         /* ❌ REMOVED — this was squishing bars and making it unscannable
  //         .barcode-svg-wrapper svg {
  //           width: 100% !important;
  //           height: 100% !important;
  //           display: block;
  //         } */
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               background: "#fff",
  //             }}
  //           >

  //             {/* ===== 1. MATERIAL TEXT ON TOP ===== */}
  //             <div
  //               style={{
  //                 width: "86px",
  //                 padding: "2px 0",
  //                 borderBottom: "1px solid #ccc",
  //                 marginBottom: "4px",
  //                 textAlign: "center",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.4",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div>

  //             {/* ===== 2. BARCODE — natural size, no CSS stretch ===== */}
  //             <div
  //               style={{
  //                 flex: 1,
  //                 width: "86px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 {/* ✅ overflow: visible — let barcode breathe at natural size */}
  //                 <div style={{ overflow: "visible" }}>
  //                   <Barcode
  //                     value={data.barcode || "N/A"}
  //                     width={1.2}       /* ← safe bar thickness, don't force CSS on top */
  //                     height={68}
  //                     format="CODE128"
  //                     displayValue={false}
  //                     margin={2}        /* ← small margin so edge bars don't get clipped */
  //                     background="#FFFFFF"
  //                     lineColor="#000000"
  //                   />
  //                 </div>
  //               </div>
  //             </div>

  //             {/* ===== 3. BARCODE NUMBER TEXT ===== */}
  //             <div
  //               style={{
  //                 width: "86px",
  //                 textAlign: "center",
  //                 marginTop: "2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontFamily: "monospace",
  //                   letterSpacing: "0.5px",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.barcode || "N/A"}
  //               </span>
  //             </div>

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-10
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               background: "#fff",
  //             }}
  //           >

  //             {/* ===== 1. MATERIAL TEXT ON TOP — commented ===== */}
  //             {/* <div
  //               style={{
  //                 width: "86px",
  //                 padding: "2px 0",
  //                 borderBottom: "1px solid #ccc",
  //                 marginBottom: "4px",
  //                 textAlign: "center",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.4",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div> */}

  //             {/* ===== 2. BARCODE — wider gaps between bars ===== */}
  //             <div
  //               style={{
  //                 flex: 1,
  //                 width: "86px",
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 overflow: "hidden",
  //               }}
  //             >
  //               <div
  //                 style={{
  //                   transform: "rotate(90deg)",
  //                   transformOrigin: "center center",
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <div style={{ overflow: "visible" }}>
  //                   <Barcode
  //                     value={data.barcode || "N/A"}
  //                     width={0.6}       /* ← thinner bars = more visible gaps between them */
  //                     height={80}       /* ← taller bars to fill height */
  //                     format="CODE128"
  //                     displayValue={false}
  //                     margin={4}        /* ← more margin around barcode */
  //                     background="#FFFFFF"
  //                     lineColor="#000000"
  //                   />
  //                 </div>
  //               </div>
  //             </div>

  //             {/* ===== 3. BARCODE NUMBER — commented ===== */}
  //             {/* <div
  //               style={{
  //                 width: "86px",
  //                 textAlign: "center",
  //                 marginTop: "2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontFamily: "monospace",
  //                   letterSpacing: "0.5px",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.barcode || "N/A"}
  //               </span>
  //             </div> */}

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-11
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;
  //   const items = Array.from({ length: quantity > 0 ? quantity : 1 });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: 30mm 50mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-label {
  //             width: 30mm;
  //             height: 50mm;
  //             page-break-after: always;
  //             overflow: hidden;
  //             box-sizing: border-box;
  //           }
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {items.map((_, index) => (
  //           <div
  //             key={index}
  //             className="barcode-label"
  //             style={{
  //               width: "94px",
  //               height: "189px",
  //               display: "flex",
  //               flexDirection: "column",
  //               alignItems: "center",
  //               overflow: "hidden",
  //               boxSizing: "border-box",
  //               padding: "4px",
  //               background: "#fff",
  //             }}
  //           >

  //             {/* ===== 1. MATERIAL TEXT ON TOP — commented ===== */}
  //             {/* <div
  //               style={{
  //                 width: "86px",
  //                 padding: "2px 0",
  //                 borderBottom: "1px solid #ccc",
  //                 marginBottom: "4px",
  //                 textAlign: "center",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontWeight: "bold",
  //                   wordBreak: "break-word",
  //                   lineHeight: "1.4",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.materialCode} | {data.materialDescription}
  //               </span>
  //             </div> */}

  //             {/* ===== 2. BARCODE — wider gaps between bars ===== */}
  //             <div
  //   style={{
  //     flex: 1,
  //     width: "86px",
  //     display: "flex",
  //     alignItems: "center",
  //     justifyContent: "center",
  //     overflow: "hidden",
  //   }}
  // >
  //   <div
  //     style={{
  //       transform: "rotate(90deg)",
  //       transformOrigin: "center center",
  //       width: "170px",   /* ← matches label height after rotation */
  //       height: "86px",   /* ← matches label width after rotation */
  //       display: "flex",
  //       alignItems: "center",
  //       justifyContent: "center",
  //     }}
  //   >
  //     <Barcode
  //       value={data.barcode || "N/A"}
  //       width={1.5}         /* ← increased back — more bars fill the width */
  //       height={82}         /* ← fills the height */
  //       format="CODE128"
  //       displayValue={false}
  //       margin={0}          /* ← no margin, use full space */
  //       background="#FFFFFF"
  //       lineColor="#000000"
  //     />
  //   </div>
  // </div>

  //             {/* ===== 3. BARCODE NUMBER — commented ===== */}
  //             {/* <div
  //               style={{
  //                 width: "86px",
  //                 textAlign: "center",
  //                 marginTop: "2px",
  //               }}
  //             >
  //               <span
  //                 style={{
  //                   fontSize: "7px",
  //                   fontFamily: "monospace",
  //                   letterSpacing: "0.5px",
  //                   display: "block",
  //                 }}
  //               >
  //                 {data.barcode || "N/A"}
  //               </span>
  //             </div> */}

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-11
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   // Generate custom barcode SVG for 30x50mm label
  //   const generateCustomBarcode = (value) => {
  //     // CODE128 Character set B with special characters
  //     const CODE128_CHARACTERS = {
  //       '0': '11011001100', '1': '11001101100', '2': '11001100110',
  //       '3': '10010011000', '4': '10010001100', '5': '10001001100',
  //       '6': '10011001000', '7': '10011000100', '8': '10001100100',
  //       '9': '11001001000',
  //       'A': '11001000100', 'B': '11000100100', 'C': '10011101000',
  //       'D': '10011000110', 'E': '10001100110', 'F': '10110011100',
  //       'G': '10011100110', 'H': '10011100011', 'I': '11001110010',
  //       'J': '11001011100', 'K': '11001001110', 'L': '11000101110',
  //       'M': '10110011110', 'N': '10111001110', 'O': '10111000111',
  //       'P': '10111001110', 'Q': '11011100110', 'R': '11001110110',
  //       'S': '11001110011', 'T': '11011011100', 'U': '11011001110',
  //       'V': '11011100110', 'W': '11001110110', 'X': '11001110011',
  //       'Y': '11011011100', 'Z': '11011001110',
  //       'a': '10010110000', 'b': '10010001100', 'c': '10001001100',
  //       'd': '10011001000', 'e': '10011000100', 'f': '10001100100',
  //       'g': '10110010000', 'h': '10110001000', 'i': '10110000100',
  //       'j': '10011010000', 'k': '10011001000', 'l': '10011000100',
  //       'm': '10001101000', 'n': '10001100100', 'o': '10110100000',
  //       'p': '10110010000', 'q': '10110001000', 'r': '10110000100',
  //       's': '10011010000', 't': '10001011000', 'u': '10001001100',
  //       'v': '10110100000', 'w': '10100010000', 'x': '10100001000',
  //       'y': '10100000100', 'z': '10010110000',
  //       ' ': '10110010000',
  //       '!': '10010001000', '@': '10001000100',
  //       '#': '10001010000', '$': '10001001000',
  //       '%': '10000101000', '^': '10010100000',
  //       '&': '10010010000', '*': '10010000100',
  //       '(': '10000100100', ')': '10000010100',
  //       '-': '10110001000', '_': '10011000100',
  //       '.': '10011010000', '/': '10001011000',
  //       ':': '10110100000', '+': '10100010000',
  //       ';': '10001000010', '<': '10010100010',
  //       '=': '10010010010', '>': '10001010010',
  //       '?': '10101001000', ',': '10101000100',
  //       "'": '10100101000', '"': '10100010100',
  //       '[': '10100100010', ']': '10100010010',
  //       '{': '10100001010', '}': '10010101000',
  //       '|': '10010100100', '~': '10010010100',
  //       '`': '10101010000',
  //     };

  //     const START_B = '11010010000';
  //     const STOP = '1100011101011';

  //     let pattern = START_B;
  //     let checksum = 104;
  //     let position = 1;

  //     for (let char of value) {
  //       if (CODE128_CHARACTERS[char]) {
  //         pattern += CODE128_CHARACTERS[char];
  //         const charCode = Object.keys(CODE128_CHARACTERS).indexOf(char);
  //         checksum += charCode * position;
  //         position++;
  //       }
  //     }

  //     checksum = checksum % 103;
  //     const checksumPattern = Object.values(CODE128_CHARACTERS)[checksum];
  //     if (checksumPattern) {
  //       pattern += checksumPattern;
  //     }
  //     pattern += STOP;

  //     return pattern;
  //   };

  //   const barcodePattern = generateCustomBarcode(data.barcode || "N/A");

  //   // Label dimensions: 30mm width x 50mm height
  //   const labelWidthMm = 30;
  //   const labelHeightMm = 50;
  //   const barcodeLengthMm = 42;   // Length of barcode (along 50mm dimension)
  //   const barcodeBarHeightMm = 26; // Height/length of each bar (spans 30mm width after rotation)

  //   // Calculate bar width - each module gets equal space
  //   const totalModules = barcodePattern.length;
  //   const barSpacingMm = (barcodeLengthMm - 6) / totalModules; // 3mm margin top/bottom

  //   // Create individual bars array
  //   const bars = [];
  //   let currentY = 3; // Start 3mm from top
  //   barcodePattern.split('').forEach((bit, index) => {
  //     if (bit === '1') {
  //       bars.push({
  //         x: 0,
  //         y: currentY,
  //         width: barcodeBarHeightMm,
  //         height: barSpacingMm * 0.9, // 10% gap between bars for scanning
  //       });
  //     }
  //     currentY += barSpacingMm;
  //   });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: ${labelWidthMm}mm ${labelHeightMm}mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-page {
  //             width: ${labelWidthMm}mm;
  //             height: ${labelHeightMm}mm;
  //             page-break-after: always;
  //             display: flex;
  //             flex-direction: column;
  //             align-items: center;
  //             justify-content: center;
  //             background: #FFFFFF;
  //             padding: 2mm;
  //             box-sizing: border-box;
  //           }
  //         }
  //         .barcode-page {
  //           width: ${labelWidthMm}mm;
  //           height: ${labelHeightMm}mm;
  //           display: flex;
  //           flex-direction: column;
  //           align-items: center;
  //           justify-content: center;
  //           background: #FFFFFF;
  //           padding: 2mm;
  //           box-sizing: border-box;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {/* Render one barcode per page for each quantity */}
  //         {Array.from({ length: quantity > 0 ? quantity : 1 }).map((_, idx) => (
  //           <div key={idx} className="barcode-page">
  //             {/* Container for rotated barcode - centered vertically */}
  //             <div
  //               style={{
  //                 display: "flex",
  //                 alignItems: "center",
  //                 justifyContent: "center",
  //                 transform: "rotate(90deg)",
  //                 transformOrigin: "center center",
  //                 width: `${barcodeLengthMm}mm`,
  //                 height: `${barcodeBarHeightMm}mm`,
  //               }}
  //             >
  //               <svg
  //                 width={`${barcodeBarHeightMm}mm`}
  //                 height={`${barcodeLengthMm}mm`}
  //                 viewBox={`0 0 ${barcodeBarHeightMm} ${barcodeLengthMm}`}
  //                 style={{
  //                   background: "#FFFFFF",
  //                 }}
  //               >
  //                 {bars.map((bar, i) => (
  //                   <rect
  //                     key={i}
  //                     x={bar.x}
  //                     y={bar.y}
  //                     width={bar.width}
  //                     height={bar.height}
  //                     fill="#000000"
  //                   />
  //                 ))}
  //               </svg>
  //             </div>

  //             {/* Barcode text - also rotated 90 degrees */}
  //             <div
  //               style={{
  //                 marginTop: "5mm",
  //                 fontSize: "11pt",
  //                 fontFamily: "Arial, sans-serif",
  //                 fontWeight: "bold",
  //                 textAlign: "center",
  //                 letterSpacing: "2px",
  //                 transform: "rotate(90deg)",
  //                 transformOrigin: "center center",
  //               }}
  //             >
  //               {data.barcode || "N/A"}
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-12
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   const generateCustomBarcode = (value) => {
  //     const CODE128_CHARACTERS = {
  //       '0': '11011001100', '1': '11001101100', '2': '11001100110',
  //       '3': '10010011000', '4': '10010001100', '5': '10001001100',
  //       '6': '10011001000', '7': '10011000100', '8': '10001100100',
  //       '9': '11001001000',
  //       'A': '11001000100', 'B': '11000100100', 'C': '10011101000',
  //       'D': '10011000110', 'E': '10001100110', 'F': '10110011100',
  //       'G': '10011100110', 'H': '10011100011', 'I': '11001110010',
  //       'J': '11001011100', 'K': '11001001110', 'L': '11000101110',
  //       'M': '10110011110', 'N': '10111001110', 'O': '10111000111',
  //       'P': '10111001110', 'Q': '11011100110', 'R': '11001110110',
  //       'S': '11001110011', 'T': '11011011100', 'U': '11011001110',
  //       'V': '11011100110', 'W': '11001110110', 'X': '11001110011',
  //       'Y': '11011011100', 'Z': '11011001110',
  //       'a': '10010110000', 'b': '10010001100', 'c': '10001001100',
  //       'd': '10011001000', 'e': '10011000100', 'f': '10001100100',
  //       'g': '10110010000', 'h': '10110001000', 'i': '10110000100',
  //       'j': '10011010000', 'k': '10011001000', 'l': '10011000100',
  //       'm': '10001101000', 'n': '10001100100', 'o': '10110100000',
  //       'p': '10110010000', 'q': '10110001000', 'r': '10110000100',
  //       's': '10011010000', 't': '10001011000', 'u': '10001001100',
  //       'v': '10110100000', 'w': '10100010000', 'x': '10100001000',
  //       'y': '10100000100', 'z': '10010110000',
  //       ' ': '10110010000',
  //       '!': '10010001000', '@': '10001000100',
  //       '#': '10001010000', '$': '10001001000',
  //       '%': '10000101000', '^': '10010100000',
  //       '&': '10010010000', '*': '10010000100',
  //       '(': '10000100100', ')': '10000010100',
  //       '-': '10110001000', '_': '10011000100',
  //       '.': '10011010000', '/': '10001011000',
  //       ':': '10110100000', '+': '10100010000',
  //       ';': '10001000010', '<': '10010100010',
  //       '=': '10010010010', '>': '10001010010',
  //       '?': '10101001000', ',': '10101000100',
  //       "'": '10100101000', '"': '10100010100',
  //       '[': '10100100010', ']': '10100010010',
  //       '{': '10100001010', '}': '10010101000',
  //       '|': '10010100100', '~': '10010010100',
  //       '`': '10101010000',
  //     };

  //     const START_B = '11010010000';
  //     const STOP = '1100011101011';

  //     let pattern = START_B;
  //     let checksum = 104;
  //     let position = 1;

  //     for (let char of value) {
  //       if (CODE128_CHARACTERS[char]) {
  //         pattern += CODE128_CHARACTERS[char];
  //         const charCode = Object.keys(CODE128_CHARACTERS).indexOf(char);
  //         checksum += charCode * position;
  //         position++;
  //       }
  //     }

  //     checksum = checksum % 103;
  //     const checksumPattern = Object.values(CODE128_CHARACTERS)[checksum];
  //     if (checksumPattern) {
  //       pattern += checksumPattern;
  //     }
  //     pattern += STOP;

  //     return pattern;
  //   };

  //   const barcodePattern = generateCustomBarcode(data.barcode || "N/A");

  //   // Label dimensions: 30mm width x 50mm height
  //   const labelWidthMm = 30;
  //   const labelHeightMm = 50;

  //   // Barcode rendered horizontally (no rotation)
  //   // Width spans most of the 30mm label width, height is the bar height
  //   const barcodeWidthMm = 26;   // horizontal span across the label (30mm - margins)
  //   const barcodeBarHeightMm = 30; // tall vertical bars (increased height)

  //   const totalModules = barcodePattern.length;
  //   const moduleWidthMm = barcodeWidthMm / totalModules;

  //   // Build bars as vertical stripes going left-to-right
  //   const bars = [];
  //   barcodePattern.split('').forEach((bit, index) => {
  //     if (bit === '1') {
  //       bars.push({
  //         x: index * moduleWidthMm,
  //         y: 0,
  //         width: moduleWidthMm * 0.85, // slight gap between modules
  //         height: barcodeBarHeightMm,
  //       });
  //     }
  //   });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: ${labelWidthMm}mm ${labelHeightMm}mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-page {
  //             width: ${labelWidthMm}mm;
  //             height: ${labelHeightMm}mm;
  //             page-break-after: always;
  //             display: flex;
  //             flex-direction: column;
  //             align-items: center;
  //             justify-content: center;
  //             background: #FFFFFF;
  //             padding: 2mm;
  //             box-sizing: border-box;
  //           }
  //         }
  //         .barcode-page {
  //           width: ${labelWidthMm}mm;
  //           height: ${labelHeightMm}mm;
  //           display: flex;
  //           flex-direction: column;
  //           align-items: center;
  //           justify-content: center;
  //           background: #FFFFFF;
  //           padding: 2mm;
  //           box-sizing: border-box;
  //         }
  //         .barcode-number {
  //           margin-top: 2mm;
  //           font-size: 7pt;
  //           font-family: Arial, sans-serif;
  //           font-weight: bold;
  //           text-align: center;
  //           letter-spacing: 1px;
  //           width: ${barcodeWidthMm}mm;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {Array.from({ length: quantity > 0 ? quantity : 1 }).map((_, idx) => (
  //           <div key={idx} className="barcode-page">
  //             {/* Horizontal barcode SVG - no rotation */}
  //             <svg
  //               width={`${barcodeWidthMm}mm`}
  //               height={`${barcodeBarHeightMm}mm`}
  //               viewBox={`0 0 ${barcodeWidthMm} ${barcodeBarHeightMm}`}
  //               style={{ background: "#FFFFFF", display: "block" }}
  //             >
  //               {bars.map((bar, i) => (
  //                 <rect
  //                   key={i}
  //                   x={bar.x}
  //                   y={bar.y}
  //                   width={bar.width}
  //                   height={bar.height}
  //                   fill="#000000"
  //                 />
  //               ))}
  //             </svg>

  //             {/* Barcode number centered below */}
  //             <div className="barcode-number">
  //               {data.barcode || "N/A"}
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-13
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   const generateCustomBarcode = (value) => {
  //     const CODE128_CHARACTERS = {
  //       '0': '11011001100', '1': '11001101100', '2': '11001100110',
  //       '3': '10010011000', '4': '10010001100', '5': '10001001100',
  //       '6': '10011001000', '7': '10011000100', '8': '10001100100',
  //       '9': '11001001000',
  //       'A': '11001000100', 'B': '11000100100', 'C': '10011101000',
  //       'D': '10011000110', 'E': '10001100110', 'F': '10110011100',
  //       'G': '10011100110', 'H': '10011100011', 'I': '11001110010',
  //       'J': '11001011100', 'K': '11001001110', 'L': '11000101110',
  //       'M': '10110011110', 'N': '10111001110', 'O': '10111000111',
  //       'P': '10111001110', 'Q': '11011100110', 'R': '11001110110',
  //       'S': '11001110011', 'T': '11011011100', 'U': '11011001110',
  //       'V': '11011100110', 'W': '11001110110', 'X': '11001110011',
  //       'Y': '11011011100', 'Z': '11011001110',
  //       'a': '10010110000', 'b': '10010001100', 'c': '10001001100',
  //       'd': '10011001000', 'e': '10011000100', 'f': '10001100100',
  //       'g': '10110010000', 'h': '10110001000', 'i': '10110000100',
  //       'j': '10011010000', 'k': '10011001000', 'l': '10011000100',
  //       'm': '10001101000', 'n': '10001100100', 'o': '10110100000',
  //       'p': '10110010000', 'q': '10110001000', 'r': '10110000100',
  //       's': '10011010000', 't': '10001011000', 'u': '10001001100',
  //       'v': '10110100000', 'w': '10100010000', 'x': '10100001000',
  //       'y': '10100000100', 'z': '10010110000',
  //       ' ': '10110010000',
  //       '!': '10010001000', '@': '10001000100',
  //       '#': '10001010000', '$': '10001001000',
  //       '%': '10000101000', '^': '10010100000',
  //       '&': '10010010000', '*': '10010000100',
  //       '(': '10000100100', ')': '10000010100',
  //       '-': '10110001000', '_': '10011000100',
  //       '.': '10011010000', '/': '10001011000',
  //       ':': '10110100000', '+': '10100010000',
  //       ';': '10001000010', '<': '10010100010',
  //       '=': '10010010010', '>': '10001010010',
  //       '?': '10101001000', ',': '10101000100',
  //       "'": '10100101000', '"': '10100010100',
  //       '[': '10100100010', ']': '10100010010',
  //       '{': '10100001010', '}': '10010101000',
  //       '|': '10010100100', '~': '10010010100',
  //       '`': '10101010000',
  //     };

  //     const START_B = '11010010000';
  //     const STOP = '1100011101011';

  //     let pattern = START_B;
  //     let checksum = 104;
  //     let position = 1;

  //     for (let char of value) {
  //       if (CODE128_CHARACTERS[char]) {
  //         pattern += CODE128_CHARACTERS[char];
  //         const charCode = Object.keys(CODE128_CHARACTERS).indexOf(char);
  //         checksum += charCode * position;
  //         position++;
  //       }
  //     }

  //     checksum = checksum % 103;
  //     const checksumPattern = Object.values(CODE128_CHARACTERS)[checksum];
  //     if (checksumPattern) {
  //       pattern += checksumPattern;
  //     }
  //     pattern += STOP;

  //     return pattern;
  //   };

  //   const barcodePattern = generateCustomBarcode(data.barcode || "N/A");

  //   // Label dimensions: 30mm width x 50mm height
  //   const labelWidthMm = 30;
  //   const labelHeightMm = 50;

  //   // Barcode rendered rotated 90° — bars run horizontally (top to bottom)
  //   const barcodeWidthMm = 26;    // how wide the barcode spans horizontally on the label
  //   const barcodeBarHeightMm = 20; // height of each bar (horizontal thickness)

  //   const totalModules = barcodePattern.length;
  //   const moduleHeightMm = barcodeWidthMm / totalModules; // each module is a horizontal slice

  //   // Build bars as horizontal stripes going top-to-bottom
  //   const bars = [];
  //   barcodePattern.split('').forEach((bit, index) => {
  //     if (bit === '1') {
  //       bars.push({
  //         x: 0,
  //         y: index * moduleHeightMm,
  //         width: barcodeBarHeightMm,       // spans full width of the barcode
  //         height: moduleHeightMm * 0.85,   // slight gap between modules
  //       });
  //     }
  //   });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: ${labelWidthMm}mm ${labelHeightMm}mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area {
  //             position: absolute;
  //             left: 0;
  //             top: 0;
  //           }
  //           .barcode-page {
  //             width: ${labelWidthMm}mm;
  //             height: ${labelHeightMm}mm;
  //             page-break-after: always;
  //             display: flex;
  //             flex-direction: column;
  //             align-items: center;
  //             justify-content: center;
  //             background: #FFFFFF;
  //             padding: 2mm;
  //             box-sizing: border-box;
  //           }
  //         }
  //         .barcode-page {
  //           width: ${labelWidthMm}mm;
  //           height: ${labelHeightMm}mm;
  //           display: flex;
  //           flex-direction: column;
  //           align-items: center;
  //           justify-content: center;
  //           background: #FFFFFF;
  //           padding: 2mm;
  //           box-sizing: border-box;
  //         }
  //         .barcode-number {
  //           margin-top: 2mm;
  //           font-size: 7pt;
  //           font-family: Arial, sans-serif;
  //           font-weight: bold;
  //           text-align: center;
  //           letter-spacing: 1px;
  //           width: ${barcodeBarHeightMm}mm;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {Array.from({ length: quantity > 0 ? quantity : 1 }).map((_, idx) => (
  //           <div key={idx} className="barcode-page">
  //             {/* Rotated 90°: bars stack top-to-bottom across label width */}
  //             <svg
  //               width={`${barcodeBarHeightMm}mm`}
  //               height={`${barcodeWidthMm}mm`}
  //               viewBox={`0 0 ${barcodeBarHeightMm} ${barcodeWidthMm}`}
  //               style={{ background: "#FFFFFF", display: "block" }}
  //             >
  //               {bars.map((bar, i) => (
  //                 <rect
  //                   key={i}
  //                   x={bar.x}
  //                   y={bar.y}
  //                   width={bar.width}
  //                   height={bar.height}
  //                   fill="#000000"
  //                 />
  //               ))}
  //             </svg>

  //             {/* Barcode number centered below */}
  //             <div className="barcode-number">
  //               {data.barcode || "N/A"}
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-14
  // const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
  //   if (!data) return null;

  //   const generateCustomBarcode = (value) => {
  //     const CODE128_CHARACTERS = {
  //       '0': '11011001100', '1': '11001101100', '2': '11001100110',
  //       '3': '10010011000', '4': '10010001100', '5': '10001001100',
  //       '6': '10011001000', '7': '10011000100', '8': '10001100100',
  //       '9': '11001001000',
  //       'A': '11001000100', 'B': '11000100100', 'C': '10011101000',
  //       'D': '10011000110', 'E': '10001100110', 'F': '10110011100',
  //       'G': '10011100110', 'H': '10011100011', 'I': '11001110010',
  //       'J': '11001011100', 'K': '11001001110', 'L': '11000101110',
  //       'M': '10110011110', 'N': '10111001110', 'O': '10111000111',
  //       'P': '10111001110', 'Q': '11011100110', 'R': '11001110110',
  //       'S': '11001110011', 'T': '11011011100', 'U': '11011001110',
  //       'V': '11011100110', 'W': '11001110110', 'X': '11001110011',
  //       'Y': '11011011100', 'Z': '11011001110',
  //       'a': '10010110000', 'b': '10010001100', 'c': '10001001100',
  //       'd': '10011001000', 'e': '10011000100', 'f': '10001100100',
  //       'g': '10110010000', 'h': '10110001000', 'i': '10110000100',
  //       'j': '10011010000', 'k': '10011001000', 'l': '10011000100',
  //       'm': '10001101000', 'n': '10001100100', 'o': '10110100000',
  //       'p': '10110010000', 'q': '10110001000', 'r': '10110000100',
  //       's': '10011010000', 't': '10001011000', 'u': '10001001100',
  //       'v': '10110100000', 'w': '10100010000', 'x': '10100001000',
  //       'y': '10100000100', 'z': '10010110000',
  //       ' ': '10110010000',
  //       '!': '10010001000', '@': '10001000100',
  //       '#': '10001010000', '$': '10001001000',
  //       '%': '10000101000', '^': '10010100000',
  //       '&': '10010010000', '*': '10010000100',
  //       '(': '10000100100', ')': '10000010100',
  //       '-': '10110001000', '_': '10011000100',
  //       '.': '10011010000', '/': '10001011000',
  //       ':': '10110100000', '+': '10100010000',
  //       ';': '10001000010', '<': '10010100010',
  //       '=': '10010010010', '>': '10001010010',
  //       '?': '10101001000', ',': '10101000100',
  //       "'": '10100101000', '"': '10100010100',
  //       '[': '10100100010', ']': '10100010010',
  //       '{': '10100001010', '}': '10010101000',
  //       '|': '10010100100', '~': '10010010100',
  //       '`': '10101010000',
  //     };

  //     const START_B = '11010010000';
  //     const STOP = '1100011101011';

  //     let pattern = START_B;
  //     let checksum = 104;
  //     let position = 1;

  //     for (let char of value) {
  //       if (CODE128_CHARACTERS[char]) {
  //         pattern += CODE128_CHARACTERS[char];
  //         const charCode = Object.keys(CODE128_CHARACTERS).indexOf(char);
  //         checksum += charCode * position;
  //         position++;
  //       }
  //     }

  //     checksum = checksum % 103;
  //     const checksumPattern = Object.values(CODE128_CHARACTERS)[checksum];
  //     if (checksumPattern) {
  //       pattern += checksumPattern;
  //     }
  //     pattern += STOP;

  //     return pattern;
  //   };

  //   const barcodePattern = generateCustomBarcode(data.barcode || "N/A");

  //   const labelWidthMm = 30;
  //   const labelHeightMm = 50;

  //   // Barcode: horizontal stripes stacking top-to-bottom (rotated 90°)
  //   const barcodeHeightMm = 42;   // tall - nearly full label height
  //   const barcodeBarWidthMm = 22; // width of bars across label

  //   const totalModules = barcodePattern.length;
  //   const moduleHeightMm = barcodeHeightMm / totalModules;

  //   const bars = [];
  //   barcodePattern.split('').forEach((bit, index) => {
  //     if (bit === '1') {
  //       bars.push({
  //         x: 0,
  //         y: index * moduleHeightMm,
  //         width: barcodeBarWidthMm,
  //         height: moduleHeightMm * 0.85,
  //       });
  //     }
  //   });

  //   return (
  //     <>
  //       <style>{`
  //         @media print {
  //           @page {
  //             size: ${labelWidthMm}mm ${labelHeightMm}mm;
  //             margin: 0;
  //           }
  //           body * { visibility: hidden; }
  //           #barcode-print-area, #barcode-print-area * { visibility: visible; }
  //           #barcode-print-area { position: absolute; left: 0; top: 0; }
  //           .barcode-page {
  //             width: ${labelWidthMm}mm;
  //             height: ${labelHeightMm}mm;
  //             page-break-after: always;
  //             display: flex;
  //             flex-direction: row;
  //             align-items: center;
  //             justify-content: center;
  //             background: #FFFFFF;
  //             padding: 2mm;
  //             box-sizing: border-box;
  //           }
  //         }
  //         .barcode-page {
  //           width: ${labelWidthMm}mm;
  //           height: ${labelHeightMm}mm;
  //           display: flex;
  //           flex-direction: row;
  //           align-items: center;
  //           justify-content: center;
  //           background: #FFFFFF;
  //           padding: 2mm;
  //           box-sizing: border-box;
  //           overflow: hidden;
  //         }
  //         .barcode-number-wrapper {
  //           width: 6mm;
  //           height: ${barcodeHeightMm}mm;
  //           display: flex;
  //           align-items: center;
  //           justify-content: center;
  //           flex-shrink: 0;
  //           overflow: visible;
  //         }
  //         .barcode-number {
  //           font-size: 6pt;
  //           font-family: Arial, sans-serif;
  //           font-weight: bold;
  //           letter-spacing: 1px;
  //           white-space: nowrap;
  //           transform: rotate(-90deg);
  //           display: block;
  //         }
  //       `}</style>

  //       <div id="barcode-print-area" ref={ref}>
  //         {Array.from({ length: quantity > 0 ? quantity : 1 }).map((_, idx) => (
  //           <div key={idx} className="barcode-page">

  //             {/* Number rotated 90°, on the LEFT */}
  //             <div className="barcode-number-wrapper">
  //               <span className="barcode-number">{data.barcode || "N/A"}</span>
  //             </div>

  //             {/* Barcode: horizontal stripes */}
  //             <svg
  //               width={`${barcodeBarWidthMm}mm`}
  //               height={`${barcodeHeightMm}mm`}
  //               viewBox={`0 0 ${barcodeBarWidthMm} ${barcodeHeightMm}`}
  //               style={{ background: "#FFFFFF", display: "block", flexShrink: 0 }}
  //             >
  //               {bars.map((bar, i) => (
  //                 <rect
  //                   key={i}
  //                   x={bar.x}
  //                   y={bar.y}
  //                   width={bar.width}
  //                   height={bar.height}
  //                   fill="#000000"
  //                 />
  //               ))}
  //             </svg>

  //           </div>
  //         ))}
  //       </div>
  //     </>
  //   );
  // });
  //test-15
  const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    return (
      <>
        <style>{`
        @media print {
          @page {
            size: 30mm 50mm;
            margin: 0;
          }
          body * { visibility: hidden; }
          #barcode-print-area, #barcode-print-area * { visibility: visible; }
          #barcode-print-area {
            position: absolute;
            left: 2mm;
            top: 2mm;
            width: 30mm;
          }
          .barcode-label {
            width: 30mm;
            height: 50mm;
            page-break-after: always;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
      `}</style>

        <div id="barcode-print-area" ref={ref}>
          {items.map((_, index) => (
            // <div
            //   key={index}
            //   className="barcode-label"
            //   style={{
            //     width: "113px",    // 30mm
            //     height: "189px",   // 50mm
            //     border: "1.5px solid #000",  // ✅ clean border
            //     borderRadius: "3px",
            //     display: "flex",
            //     flexDirection: "row",  // ✅ row — barcode left, text right
            //     alignItems: "center",
            //     justifyContent: "center",
            //     marginBottom: "8px",
            //     overflow: "hidden",
            //     boxSizing: "border-box",
            //     padding: "3px",
            //     gap: "2px",
            //   }}
            // >
            //   {/* ✅ Barcode — 90 degrees */}
            //   <div
            //     style={{
            //       transform: "rotate(90deg)",
            //       transformOrigin: "center center",
            //       width: "170px",
            //       height: "85px",
            //       display: "flex",
            //       alignItems: "center",
            //       justifyContent: "center",
            //       flexShrink: 0,
            //     }}
            //   >
            //     <Barcode
            //       value={data.barcode || "N/A"}
            //       width={1.1}
            //       height={70}
            //       format="CODE128"
            //       displayValue={true}
            //       fontSize={8}
            //       margin={1}
            //     />
            //   </div>

            //   {/*  Material name — right side, 90 degrees */}
            //   <div
            //     style={{
            //       display: "flex",
            //       flexDirection: "column",
            //       alignItems: "center",
            //       justifyContent: "center",
            //       flexShrink: 0,
            //       width: "22px",
            //     }}
            //   >
            //     <span
            //       style={{
            //         transform: "rotate(90deg)",
            //         transformOrigin: "center center",
            //         whiteSpace: "nowrap",
            //         fontSize: "7px",
            //         fontWeight: "bold",
            //         display: "block",
            //         width: "170px",
            //         textAlign: "center",
            //       }}
            //     >
            //       {/* {data.materialCode} | {data.materialDescription} */}
            //       <strong>{data.materialDescription}</strong>
            //     </span>
            //   </div>
            // </div>
            <div
              key={index}
              className="barcode-label"
              style={{
                width: "113px",
                height: "189px",
                // border: "1.5px solid #000",
                borderRadius: "3px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                margin: "6px",
                marginBottom: "8px",
                overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
                boxSizing: "border-box",
                padding: "4px",
                gap: "2px",
                position: "relative", //  add this
              }}
            >
              {/*  Barcode wrapper — strictly contained */}
              <div
                style={{
                  width: "85px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    width: "155px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Barcode
                    value={data.barcode || "N/A"}
                    width={1.0}
                    height={58}
                    format="CODE128"
                    displayValue={true}
                    fontSize={15}
                    fontWeight={30}
                    margin={1}
                  />
                </div>
              </div>

              {/*  Material name — right side */}
              <div
                style={{
                  width: "20px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <span
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    whiteSpace: "nowrap",
                    fontSize: "6px",
                    fontWeight: "bold",
                    width: "155px",
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {/* {data.materialCode} | {data.materialDescription} */}
                </span>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  });

  const openPrintModal = (row, type) => {
    setPrintRowData(row);
    setPrintType(type); // 'BARCODE' or 'QR'
    setPrintQuantity(1); // Reset to 1 every time
    setShowPrintModal(true);
  };

  // React-to-print hooks
  // const handlePrintBarcode = useReactToPrint({
  //   contentRef: barcodeRef,
  //   documentTitle: "Barcode_Print",
  //   onAfterPrint: () => setShowPrintModal(false), // Print ayyaka modal close
  // });

  const handlePrintBarcode = useReactToPrint({
    contentRef: barcodeRef,
    documentTitle: "Barcode_Print",
    pageStyle: `@page { size: 30mm 50mm; margin: 0mm; }`,
    onAfterPrint: () => setShowPrintModal(false),
  });

  const handlePrintQr = useReactToPrint({
    contentRef: qrCodeRef,
    documentTitle: "QR_Print",
    onAfterPrint: () => setShowPrintModal(false),
  });

  const handleFinalPrint = () => {
    if (printType === "BARCODE") {
      handlePrintBarcode();
    } else if (printType === "QR") {
      handlePrintQr();
    }
  };
  const [showBarcodeHistoryModal, setShowBarcodeHistoryModal] = useState(false);
  const [selectedBarcodeHistory, setSelectedBarcodeHistory] = useState([]);

  const [showBarcodeExtendModal, setShowBarcodeExtendModal] = useState(false);
  const [selectedBarcodeExtendRow, setSelectedBarcodeExtendRow] =
    useState(null);
  //  const [showBarcodeExtendModal, setShowBarcodeExtendModal] = useState(false);

  const handleViewBarcodeExtendHistory = (row) => {
    if (!row?.barcodeExtendHistory?.length) {
      toast.error("No Barcode Extend history found");
      return;
    }
    // eslint-disable-next-line
    const handleBarcodeExtend = () => {
      setShowBarcodeExtendModal(false);
      setSelectedBarcodeExtendRow(null);
    };

    setSelectedBarcodeExtendRow(row);
    setShowBarcodeExtendModal(true);
  };

  const handleViewBarcodeERFHistory = (row) => {
    setSelectedBarcodeHistory(row.barcodeERFHistory);
    setShowBarcodeHistoryModal(true);
  };
  const getLatestBarcodeHistory = (row) => {
    if (!row?.barcodeERFHistory?.length) return null;
    return row.barcodeERFHistory[row.barcodeERFHistory.length - 1];
  };

  // end
  // const handleSaveQualityCheck = (qcPayload) => {
  //   // console.log("Saving QC Payload:", qcPayload);

  //   setQualityCheckItems((prev) =>
  //     prev.map((item) => {
  //       if (item.grnItemNr !== qcPayload.grnItemNr) {
  //         return item;
  //       }

  //       return {
  //         ...item,

  //         //  merge QC form values
  //         ...qcPayload,

  //         //  update flags correctly
  //         hasPhysicalQC:
  //           qcPayload.qcType === "PHYSICAL" ? true : item.hasPhysicalQC,

  //         hasSpecificationQC:
  //           qcPayload.qcType === "SPECIFICATION"
  //             ? true
  //             : item.hasSpecificationQC,
  //       };
  //     })
  //   );
  // };

  // const getRoiExpiryFromCreatedAt = (createdAt) => {
  //   if (!createdAt) return "--";

  //   const date = new Date(createdAt);
  //   date.setMonth(date.getMonth() + 36);

  //   return date.toLocaleString("en-GB", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //   });
  // };

  // const getRoiAgeFromCreatedAt = (createdAt) => {
  //   if (!createdAt) return "--";

  //   const start = new Date(createdAt);
  //   const now = new Date();

  //   if (now < start) return "0 Days";

  //   let years = now.getFullYear() - start.getFullYear();
  //   let months = now.getMonth() - start.getMonth();
  //   let days = now.getDate() - start.getDate();

  //   if (days < 0) {
  //     const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  //     days += prevMonth.getDate();
  //     months -= 1;
  //   }

  //   if (months < 0) {
  //     months += 12;
  //     years -= 1;
  //   }

  //   const totalMonths = years * 12 + months;

  //   // Time difference
  //   let hours = now.getHours() - start.getHours();
  //   let minutes = now.getMinutes() - start.getMinutes();

  //   if (minutes < 0) {
  //     minutes += 60;
  //     hours -= 1;
  //   }

  //   if (hours < 0) {
  //     hours += 24;
  //   }

  //   let result = "";
  //   if (totalMonths > 0) result += `${totalMonths} Month${totalMonths > 1 ? "s" : ""} `;
  //   result += `${days} Day${days !== 1 ? "s" : ""} `;
  //   result += `${hours}h ${minutes}m`;

  //   return result.trim();
  // };

  const isRentGodown = materialData?.some((row) => row.godown === "Rent");

  const rentOnlyColumns = [
    {
      name: "Created On",
      selector: (row) => row.createdOn || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-success">
          {formatDate(row.createdOn)}
        </p>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "ROI (Months)",
      selector: (row) => row.roiCodeMonths || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.roiCodeMonths}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "ROI Expiry Date",
      selector: (row) =>
        getRoiExpiryDate(row.createdOn)
          ? formatDate(getRoiExpiryDate(row.createdOn))
          : "--",
      cell: (row) => {
        const expiryDate = getRoiExpiryDate(row.createdOn);
        return (
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {expiryDate ? formatDate(expiryDate) : "--"}
          </p>
        );
      },
      sortable: true,
      width: "160px",
    },
    {
      name: "ROI Age",
      selector: (row) => getRoiAgeMonthsDays(row.createdOn || row.createdDate),
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">
          {getRoiAgeMonthsDays(row.createdOn || row.createdDate)}
        </p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "AC Asset Type",
      selector: (row) => row.acAssetType || "--",
      cell: (row) => (
        <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.acAssetType}</p>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Asset Status",
      cell: (row) => (
        <TableStatusField
          status={row.assetActiveInactive ? "Active" : "Inactive"}
        />
      ),
      width: "130px",
    },
  ];

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleViewConversionHistory = (row) => {
    setSelectedRowData(row);
    setShowHistoryModal(true);
  };

  const columns = [
    {
      name: "Edit Barcode",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100 text-success"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct12("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Edit ROI",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },

    {
      name: "Barcode Code",
      id: "barcode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.barcode || "--",
      cell: (row) => (
        <div className="ms-2">
          <p className="m-0 p-0 pt-1 fw-medium">{row?.barcode} </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Barcode",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrint(row)}
          // NEW:
          onClick={() => openPrintModal(row, "BARCODE")}
          title="Print Barcode"
        >
          <i className="bi bi-upc-scan"></i>
          Print
        </button>
      ),
      width: "120px",
    },
    {
      name: "QR Code",
      cell: (row) => (
        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
          // OLD: onClick={() => triggerPrintQrCode(row)}
          // NEW:
          onClick={() => openPrintModal(row, "QR")}
          title="Print QR Code"
        >
          <i className="bi bi-qr-code-scan"></i>
          Print QR
        </button>
      ),
      width: "130px",
    },
    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },

    {
      name: "Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{"1"} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },

    {
      name: "Rate",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.orderPriceUnit ?? row.unitPrice}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "M R P",
      selector: (row) => row.mrPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.mrPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Quality Check",
      width: "260px",
      cell: (row) => (
        <div className="d-flex gap-4 ms-1 align-items-center">
          {/* 🔹 PHYSICAL QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasPhysicalQC) {
                handleViewQC("PHYSICAL", row);
              } else {
                handleQCCheck("PHYSICAL", row);
              }
            }}
            title={row.hasPhysicalQC ? "View Physical QC" : "Add Physical QC"}
          >
            <i
              className={`bi ${
                row.hasPhysicalQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Physical</span>
          </div>

          {/* 🔹 SPECIFICATION QC */}
          <div
            className="d-flex align-items-center gap-1 cursor-pointer"
            onClick={() => {
              if (row.hasSpecificationQC) {
                handleViewQC("SPECIFICATION", row);
              } else {
                handleQCCheck("SPECIFICATION", row);
              }
            }}
            title={
              row.hasSpecificationQC
                ? "View Specification QC"
                : "Add Specification QC"
            }
          >
            <i
              className={`bi ${
                row.hasSpecificationQC
                  ? "bi-check-circle-fill text-success"
                  : "bi-clipboard-plus text-primary"
              } fs-5`}
            />
            <span className="fw-bold">Specification</span>
          </div>
        </div>
      ),
    },
    {
      name: "History",
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center">
          {row.conversionHistory && row.conversionHistory.length > 0 ? (
            <button
              className="btn btn-link p-0 border-0 position-relative"
              title="View Conversion History"
              onClick={() => handleViewConversionHistory(row)}
            >
              <i className="bi bi-clock-history fs-3 text-info"></i>
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-info"
                style={{ fontSize: "0.6rem", padding: "2px 4px" }}
              >
                {row.conversionHistory.length}
              </span>
            </button>
          ) : (
            <span className="text-muted" style={{ fontSize: "0.8rem" }}>
              --
            </span>
          )}
        </div>
      ),
      width: "90px",
    },
    ...(isRentGodown ? rentOnlyColumns : []),

    {
      name: "Godown",
      selector: (row) => row.godown,
      sortable: true,
      width: "180px",
      cell: (row) => {
        const value = row.godown;

        const color =
          value === "Rent" ? "red" : value === "Sale" ? "green" : "inherit";

        return <span style={{ color, fontWeight: 600 }}>{value}</span>;
      },
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="d-flex align-items-center gap-2">
          <OverlayTrigger
            placement="bottom"
            delay={{ show: 150, hide: 200 }}
            overlay={
              <Tooltip
                id={`tooltip-${row.documentNumber}`}
                className="custom-tooltip"
                target={target.current}
              >
                <div style={{ textAlign: "left" }}>
                  {/* <strong>Location:</strong> {row.location} <br /> */}

                  <strong>Remarks:</strong>
                  {row?.remarks || "--"}
                  <br />
                  <strong>Created By:</strong>
                  {row?.createdBy || "--"}
                  <br />
                  <strong>Created Date:</strong>
                  {row?.createdDate || "--"}
                  <br />
                  <strong>Updated Date:</strong>
                  {row?.updatedDate || "--"}
                  <br />
                  {/* <strong>Roi Code (Months):</strong>
                  {row?.roiCodeMonths || "--"}
                  <br />
                  <strong>ROI Profile Name:</strong>
                  {row?.roiProfileName || "--"}
                  <br />
                  <strong>Ac Asset Type:</strong>
                  {row?.acAssetType || "--"}
                  <br />
                  <strong>Effective Date:</strong>
                  {row?.effectiveDate || "--"}
                  <br /> */}
                </div>
              </Tooltip>
            }
          >
            <button
              className="btn btn-light p-1 border-0"
              title="View Details"
              // onClick={() => handleViewDetails(row)}
            >
              <i className="bi bi-eye fs-5 text-primary"></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Assiging Barcode",
      selector: (row) => row.assignBarcode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.assignBarcode ? "true" : "--"}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "ERF Item Nr",
      selector: (row) => getLatestBarcodeHistory(row)?.equipmentItemNr ?? "--",
      cell: (row) => {
        const latest = getLatestBarcodeHistory(row);

        return (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">
              {latest?.equipmentItemNr ?? "--"}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "ERF Nr",
      selector: (row) => getLatestBarcodeHistory(row)?.equipmentRentNr ?? "--",
      cell: (row) => {
        const latest = getLatestBarcodeHistory(row);

        return (
          <div>
            <p className="m-0 p-0 pt-1 fw-bold">
              {latest?.equipmentRentNr ?? "--"}
            </p>
          </div>
        );
      },
      sortable: true,
      width: "150px",
    },
    {
      name: "Material Status",

      selector: (row) => row.materialStatus || "--",

      cell: (row) => {
        const status = row.materialStatus;

        const statusColor =
          status === "StockIn"
            ? "text-success"
            : status === "StockOut"
              ? "text-danger"
              : "text-muted";

        return (
          <div>
            <p className={`m-0 p-0 pt-1 fw-bold ${statusColor}`}>
              {status ?? "--"}
            </p>
          </div>
        );
      },

      sortable: true,

      width: "165px",
    },

    {
      name: "Barcode ERF",
      width: "120px",
      cell: (row) => (
        <div className="flex items-center justify-center">
          {row.barcodeERFHistory && row.barcodeERFHistory.length > 0 ? (
            <div
              title="View Barcode ERF History"
              onClick={() => handleViewBarcodeERFHistory(row)}
              className="relative cursor-pointer group"
            >
              {/* Icon */}
              <i className="bi bi-upc-scan text-green-600 text-2xl group-hover:scale-110 transition-transform duration-200"></i>

              {/* Count badge */}
              <span className="absolute -top-1 -right-3 bg-green-600 text-[10px] px-1.5 py-[1px] rounded-full text-white font-medium">
                {row.barcodeERFHistory.length}
              </span>
            </div>
          ) : (
            <span className="text-gray-400 text-xs">--</span>
          )}
        </div>
      ),
    },

    {
      name: "Barcode Extend",
      width: "130px",
      cell: (row) => (
        <div className="flex items-center justify-center">
          {row.barcodeExtendHistory && row.barcodeExtendHistory.length > 0 ? (
            <div
              title="View Barcode Extend History"
              onClick={() => handleViewBarcodeExtendHistory(row)}
              className="relative cursor-pointer group"
            >
              {/* Icon */}
              <i className="bi bi-arrow-repeat text-blue-500 text-2xl group-hover:scale-110 transition-transform duration-200"></i>

              {/* Badge */}
              <span className="absolute -top-1 -right-3 bg-blue-400 text-[10px] px-1.5 py-[1px] rounded-full text-white font-medium">
                {row.barcodeExtendHistory.length}
              </span>
            </div>
          ) : (
            <span className="text-gray-400 text-xs">--</span>
          )}
        </div>
      ),
    },

    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteMaterial(row)}>
            {/* <i class="bi bi-trash3"></i> */}
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
      omit: true,
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const [getPropsData, setPropsData] = useState();
  const showAddProduct = (mode, materialnumber, data) => {
    setModalShowAddProduct(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };
  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };

  const showAddProduct12 = (mode, materialnumber, data) => {
    setModalShowAddProductMaterial(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModalMaterial = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProductMaterial(null);
    setModalShowDetailProduct(false);
  };

  useEffect(() => {
    let obj = {
      queryName: "MaterilBarcodeListSL",
      page: 1,
      per_page: 100,
    };
    dispatch(materialBarcodeList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const handlePageChange = (page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListSL",
  //     page: page,
  //     per_page: getNewPerPage,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };
  const handlePageChange = (page) => {
    let obj = {
      queryName: "MaterilBarcodeListSL",
      page: page,
      per_page: getNewPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    dispatch(materialBarcodeList(obj));
  };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListSL",
  //     page: page,
  //     per_page: newPerPage,
  //   };
  //   setNewPerPage(newPerPage);
  //   dispatch(materialBarcodeList(obj));
  // };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "MaterilBarcodeListSL",
      page: page,
      per_page: newPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(materialBarcodeList(obj));
  };

  // Common Search Function on button
  // const handleSearchFuncApi = async () => {
  //   let obj = {
  //     queryName: "MaterilBarcodeListSL",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: getCommonSearchTxt,
  //   };
  //   dispatch(materialBarcodeList(obj));
  // };
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "MaterilBarcodeListSL",
      page: 1,
      per_page: 100,
      searchTerm: getCommonSearchTxt,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
    };
    dispatch(materialBarcodeList(obj));
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);

  // const handleFilterData = async (filters) => {
  //   const obj = {
  //     queryName: "MaterilBarcodeListSL",
  //     page: 1,
  //     per_page: 10,
  //     searchTerm: "",
  //     rowFilter: filters.length > 0 ? { $and: filters } : {},
  //   };

  //   dispatch(materialBarcodeList(obj));
  //   };

  const handleFilterData = async (filters) => {
    setActiveFilters(filters); // ← save filters
    const obj = {
      queryName: "MaterilBarcodeListSL",
      page: 1,
      per_page: getNewPerPage,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };
    dispatch(materialBarcodeList(obj));
  };
  const filterColumns = [
    {
      id: "barcode",
      name: "Barcode Value",
      selectorKey: "barcode",
    },
    {
      id: "materialCode",
      name: "Material Code",
      selectorKey: "materialCode",
    },
    {
      id: "mrPrice",
      name: "MRP",
      selectorKey: "mrPrice",
      numberRange: true,
    },
    {
      id: "materialStatus",
      name: "Material Status",
      selectorKey: "materialStatus",
      dropDown:true,
      staticOptions:["StockIn", "StockOut"]
    },
    {
      id: "materialDescription",
      name: "Material Name",
      selectorKey: "materialDescription",
    },
    {
      id: "createdOn",
      name: "Date",
      selectorKey: "createdOn",
      month: true,
    },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Sale Material Barcode List</h2>
                <p className="subText">Sale Material Barcode List</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />

            {filterShow && (
              <MultiColumnFilter
                columns={filterColumns}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            {/* material */}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                {/* <div style={{ display: "block" }}>
        <PrintableBarcode
          ref={barcodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
       
      </div> */}
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">
                        {" "}
                        Sale Material Barcode Details
                      </span>
                      <span className="subHeaderTitle">
                        Sale Material Barcode and ROI{" "}
                      </span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/*     <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              <i class="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                        </button>
                      </Col> */}
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={materialData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_REPORT_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationDefaultPerPage={getNewPerPage}
                          paginationTotalRows={materialTable?.total || ""}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                    <Modal
                      show={showPrintModal}
                      onHide={() => setShowPrintModal(false)}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Print {printType === "QR" ? "QR Code" : "Barcode"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group>
                          <Form.Label>Enter Quantity (Copies)</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={printQuantity}
                            onChange={(e) =>
                              setPrintQuantity(parseInt(e.target.value) || 1)
                            }
                            disabled={true}
                            autoFocus
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShowPrintModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleFinalPrint}>
                          Print Copies
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    <Modal
                      show={showBarcodeHistoryModal}
                      onHide={() => setShowBarcodeHistoryModal(false)}
                      size="lg"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Barcode ERF History</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        {selectedBarcodeHistory?.length > 0 ? (
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Status</th>
                                <th>ERF Nr</th>
                                <th>Item Nr</th>
                                <th>Type</th>
                                <th>Updated By</th>
                                <th>Date</th>
                                <th>ERF Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {selectedBarcodeHistory.map((item, index) => (
                                <tr key={index}>
                                  <td>{item.status}</td>
                                  <td>{item.equipmentRentNr}</td>
                                  <td>{item.equipmentItemNr}</td>
                                  <td>{item.erfTypeCode}</td>
                                  <td>{item.updatedByName}</td>
                                  <td>
                                    {item.updatedAt
                                      ? new Date(
                                          item.updatedAt,
                                        ).toLocaleString()
                                      : "--"}
                                  </td>
                                  <td>{item.erfStatus}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p className="text-center">No history found</p>
                        )}
                      </Modal.Body>
                    </Modal>
                    <Modal
                      show={showBarcodeExtendModal}
                      // onHide={handleBarcodeExtend}setShowBarcodeExtendModal
                      onHide={() => setShowBarcodeExtendModal(false)}
                      size="lg"
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Barcode Extend History</Modal.Title>
                      </Modal.Header>

                      <Modal.Body>
                        {selectedBarcodeExtendRow?.barcodeExtendHistory
                          ?.length > 0 ? (
                          <div className="table-responsive">
                            <table className="table table-bordered">
                              <thead className="table-light">
                                <tr>
                                  <th>Status</th>
                                  <th>ERF Nr</th>
                                  <th>Item Nr</th>
                                  <th>Extended By</th>
                                  <th>Date</th>
                                  <th>ERF Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {selectedBarcodeExtendRow.barcodeExtendHistory.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item.status || "--"}</td>
                                      <td>{item.equipmentRentNr || "--"}</td>
                                      <td>{item.equipmentItemNr || "--"}</td>
                                      <td>{item.createdByName || "--"}</td>
                                      <td>
                                        {item.createdAt
                                          ? new Date(
                                              item.createdAt,
                                            ).toLocaleString()
                                          : "--"}
                                      </td>
                                      <td>{item.erfStatus || "--"}</td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <p className="text-center text-muted">
                            No extend history available
                          </p>
                        )}
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterialV5
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialBarCodeModal
        show={modalShowAddProduct}
        onHide={() => {
          setModalShowAddProduct(null);
          setModalShowDetailProduct(false);
        }}
        data={getPropsData}
        perPage={getNewPerPage}
        queryName="MaterilBarcodeListSL"
      />
      <MaterialHBModalV5Barcode
        show={modalShowAddProductMaterial}
        // show={true}
        onHide={() => hideModalMaterial()}
        data={getPropsData}
        type={"SL"}
      />

      <CatalogProductDetailModalV5
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <MaterialListQualityCheckModal
        show={showQCModal}
        onHide={() => setShowQCModal(false)}
        qcType={qcType}
        rowData={selectedRow}
        // editMode={editMode}
        onSaveQualityCheck={handleSaveQualityCheck}
      />
      <ConversionHistoryModal
        show={showHistoryModal}
        onHide={() => setShowHistoryModal(false)}
        data={selectedRowData}
      />
      <div style={{ display: "none" }}>
        <PrintableBarcode
          ref={barcodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
        <PrintableQrcode
          ref={qrCodeRef}
          data={printRowData}
          quantity={printQuantity}
        />
      </div>
    </main>
  );
};

export default MaterialBarcodeList;
